import React, { Component } from "react";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ButtonGridItem from "./components/ButtonGridItem";

export class AdminMenu extends Component {
    render() {
        return (
            <div className="home">
                <Typography variant={"h4"} align={"center"}> Experiment Analysis Tracking </Typography>
                <hr className = "divider"/>
                <div className="ctas">
                    <div className="container">
                        <Grid container direction={"column"} justify={"center"} spacing={2}>
                            <ButtonGridItem link="#/admin/aspera" label="RED IRIS ASPERA SHARES SUMMARY STATUS"/>
                            <ButtonGridItem link="#/admin/experimentprogress" label="EXPERIMENT ANALYSIS STATUS"/>
                            <ButtonGridItem link="#/admin/experimentsnofiles" label="EXPERIMENTS WITHOUT FILES DECLARED"/>
                            <ButtonGridItem link="#/admin/experimentshistoricreport" label="EXPERIMENTS HISTORIC REPORT"/>
                            <ButtonGridItem link="#/admin/filesstatus" label="FILE ANALYSIS STATUS"/>
                            <ButtonGridItem link="#/admin/experimentbatchedition" label="EXPERIMENT BATCH EDITION"/>
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }
}
